module.exports = __webpack_public_path__ + "img/a5.88adc007.jpg";